import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable()
export class Utf8Interceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const contentType = event.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            const body = event.body;
            if (body && typeof body === 'object') {
              this.decodeUtf8(body);
            }
          }
        }
        return event;
      })
    );
  }

  private decodeUtf8(obj: any) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'string') {
          obj[key] = decodeURIComponent(escape(obj[key]));
        } else if (typeof obj[key] === 'object') {
          this.decodeUtf8(obj[key]);
        }
      }
    }
  }
}

export const UTFInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: Utf8Interceptor,
    multi: true,
  },
];
